export default {
  getCachedCorner: state => (cornerId) => {
    return state.cachedCorners.find(corner => corner.id === cornerId)
  }
}
